
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/templates-rewrite",
      function () {
        return require("private-next-pages/templates-rewrite.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/templates-rewrite"])
      });
    }
  